import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl-next';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import ChevronUpIcon from '@atlaskit/icon/glyph/chevron-up';
import { Box, Inline, Stack, xcss } from '@atlaskit/primitives';
import { css } from '@emotion/react';
import { messages } from '../../../../../../../messages';
import { getFormattedMessageAsString } from '../../../../../components/utils';
import Text from '../../../../elements/text';
import ResolvedResultsStack from './resolved-result-stack';
var RelatedUrlList = function RelatedUrlList(_ref) {
  var resolvedResults = _ref.resolvedResults,
    title = _ref.title,
    renderers = _ref.renderers,
    testId = _ref.testId,
    initializeOpened = _ref.initializeOpened;
  var _useState = useState(initializeOpened),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var chevronClickHandler = useCallback(function () {
    return setIsOpen(!isOpen);
  }, [isOpen]);
  var ChevronComponent = isOpen ? ChevronUpIcon : ChevronDownIcon;
  var intl = useIntl();
  return resolvedResults.length > 0 ? /*#__PURE__*/React.createElement(Stack, {
    testId: testId,
    xcss: xcss({
      width: '100%'
    })
  }, /*#__PURE__*/React.createElement(Box, {
    onClick: chevronClickHandler,
    testId: "".concat(testId, "-expand-title"),
    as: "button",
    backgroundColor: "color.background.neutral.subtle",
    "aria-expanded": !!isOpen,
    padding: "space.0"
  }, /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center",
    spread: "space-between"
  }, /*#__PURE__*/React.createElement(Text, {
    overrideCss: css({
      fontWeight: "var(--ds-font-weight-medium, 500)"
    }),
    message: {
      descriptor: title
    }
  }), /*#__PURE__*/React.createElement(ChevronComponent, {
    label: getFormattedMessageAsString(intl, title),
    size: 'medium'
  }))), isOpen && /*#__PURE__*/React.createElement(ResolvedResultsStack, {
    resolvedResults: resolvedResults,
    testId: testId,
    renderers: renderers
  })) : /*#__PURE__*/React.createElement(Text, {
    testId: testId,
    message: {
      descriptor: messages.related_work_items_not_found
    }
  });
};
export default RelatedUrlList;